/* Viva Lignum: small progressive enhancements. Everything works without JS except
   the gallery thumbnails, variant price update, sticky buy bar and photo upload. */
(function () {
  'use strict';

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-vl-main]');
    var thumbs = root.querySelectorAll('[data-vl-thumb]');
    var count = root.querySelector('[data-vl-count]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-vl-thumb');
        main.querySelectorAll('img').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-vl-index') === i);
        });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === btn); t.setAttribute('aria-pressed', t === btn); });
        if (count) count.textContent = (parseInt(i, 10) + 1) + ' / ' + thumbs.length;
      });
    });
  }

  /* ---------- variant select (only rendered for products with >1 variant) ---------- */
  function initVariants(root) {
    var select = root.querySelector('[data-vl-variant-select]');
    var dataEl = root.querySelector('[data-vl-variants]');
    if (!select || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var btn = form && form.querySelector('[name="add"]');
    var btnText = btn && btn.querySelector('span');
    var priceEl = root.querySelector('[data-vl-price]');
    var stickyPrice = document.querySelector('[data-vl-sticky-price]');
    var labels = JSON.parse(root.querySelector('[data-vl-labels]').textContent);
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; }
      if (btn) btn.disabled = !v.available;
      if (btnText) btnText.textContent = v.available ? labels.add + ' · ' + v.price : labels.soldOut;
      if (priceEl) priceEl.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = v.price;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* ---------- sticky buy bar: appears once the main button scrolls away ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-vl-sticky-buy]');
    var target = document.querySelector('[data-vl-buy-anchor]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
    var trigger = bar.querySelector('[data-vl-sticky-add]');
    if (trigger) trigger.addEventListener('click', function () {
      var main = document.querySelector('[data-vl-buy-anchor] [name="add"]');
      if (main && !main.disabled) { main.click(); }
      else if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  /* ---------- collection sort ---------- */
  function initSort() {
    document.querySelectorAll('[data-vl-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- inquiry: live summary + optional Cloudinary photo upload ---------- */
  function initInquiry(root) {
    var sum = root.querySelector('[data-vl-summary]');
    function updateSummary() {
      if (!sum) return;
      var picked = [];
      root.querySelectorAll('.vl-opt input:checked').forEach(function (i) { picked.push(i.value); });
      sum.textContent = picked.length ? picked.join(' · ') : '…';
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.vl-opt')) updateSummary(); });
    updateSummary();

    var up = root.querySelector('[data-vl-upload]');
    if (!up) return;
    var cloud = up.getAttribute('data-cloud');
    var preset = up.getAttribute('data-preset');
    var maxFiles = parseInt(up.getAttribute('data-max') || '5', 10);
    var input = up.querySelector('input[type="file"]');
    var list = up.querySelector('.vl-upload__list');
    var hidden = up.querySelector('input[type="hidden"]');
    var submit = root.querySelector('[data-vl-submit]');
    var urls = [];
    var pending = 0;
    function sync() {
      hidden.value = urls.join('\n');
      if (submit) submit.disabled = pending > 0;
    }
    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files, 0, Math.max(0, maxFiles - urls.length));
      files.forEach(function (file) {
        var li = document.createElement('li');
        li.textContent = file.name + ': ' + up.getAttribute('data-uploading');
        list.appendChild(li);
        if (file.size > 10 * 1024 * 1024) { li.textContent = file.name + ': ' + up.getAttribute('data-too-big'); li.className = 'is-err'; return; }
        pending++; sync();
        var fd = new FormData();
        fd.append('file', file);
        fd.append('upload_preset', preset);
        fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/image/upload', { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (!res.secure_url) throw new Error('upload');
            urls.push(res.secure_url);
            li.textContent = '✓ ' + file.name;
          })
          .catch(function () { li.textContent = file.name + ': ' + up.getAttribute('data-failed'); li.className = 'is-err'; })
          .then(function () { pending--; sync(); });
      });
      input.value = '';
    });
  }


  /* ---------- auto-fit: shrink big display text when one word is wider than its box ---------- */
  var FIT_SEL = '.vl-h, .vl-hero__word, .vl-tile__label, .vl-ct__big';
  function fitText() {
    document.querySelectorAll(FIT_SEL).forEach(function (el) {
      el.style.fontSize = '';
      if (!el.clientWidth) return;
      for (var i = 0; i < 4 && el.scrollWidth > el.clientWidth + 1; i++) {
        var fs = parseFloat(window.getComputedStyle(el).fontSize);
        el.style.fontSize = Math.max(fs * (el.clientWidth / el.scrollWidth) * 0.97, 14) + 'px';
      }
    });
  }
  var fitW = 0, fitT;
  function fitOnResize() {
    if (window.innerWidth === fitW) return;
    fitW = window.innerWidth;
    clearTimeout(fitT);
    fitT = setTimeout(fitText, 120);
  }


  /* ---------- video slider: first card autoplays muted when visible, others play on tap ---------- */
  function initVideos(root) {
    if (root.dataset.vlReady) return; root.dataset.vlReady = '1';
    var track = root.querySelector('[data-vl-vids-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vl-vcard]'));
    function vid(c) { return c.querySelector('video'); }
    function stop(c) { var v = vid(c); if (v) { v.pause(); } c.classList.remove('is-playing'); }
    function play(c) {
      cards.forEach(function (o) { if (o !== c) stop(o); });
      var v = vid(c); if (!v) return;
      v.muted = c.querySelector('[data-vl-vsound]').getAttribute('aria-pressed') !== 'true';
      if (v.preload === 'none') v.preload = 'auto';
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      c.classList.add('is-playing');
    }
    cards.forEach(function (c) {
      var v = vid(c); if (!v) return;
      v.removeAttribute('controls');
      var bar = c.querySelector('[data-vl-vbar]');
      v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
      c.querySelector('[data-vl-vplay]').addEventListener('click', function () { play(c); });
      v.addEventListener('click', function () { if (c.classList.contains('is-playing')) stop(c); else play(c); });
      var snd = c.querySelector('[data-vl-vsound]');
      snd.addEventListener('click', function (e) {
        e.stopPropagation();
        var on = snd.getAttribute('aria-pressed') !== 'true';
        snd.setAttribute('aria-pressed', on); snd.setAttribute('aria-label', on ? 'Išjungti garsą' : 'Įjungti garsą');
        v.muted = !on;
      });
    });
    var auto = root.querySelector('[data-vl-vcard][data-autoplay]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { if (auto && !reduce && !root.querySelector('.is-playing')) play(auto); }
          else { cards.forEach(stop); }
        });
      }, { threshold: 0.35 }).observe(root);
    }
    var prev = root.querySelector('[data-vl-vids-prev]'), next = root.querySelector('[data-vl-vids-next]');
    function step(dir) {
      var item = track.querySelector('.vl-vids__item');
      var w = item ? item.getBoundingClientRect().width + 12 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    function edges() {
      if (!prev) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) { prev.addEventListener('click', function () { step(-1); }); next.addEventListener('click', function () { step(1); }); }
    track.addEventListener('scroll', edges, { passive: true }); edges();
  }

  function init() {
    document.querySelectorAll('[data-vl-pdp]').forEach(function (el) { initGallery(el); initVariants(el); });
    document.querySelectorAll('[data-vl-inquiry]').forEach(initInquiry);
    initStickyBuy();
    initSort();
    document.querySelectorAll('[data-vl-vids]').forEach(initVideos);
    fitText();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', fitOnResize);
  window.addEventListener('load', fitText);
})();
